export const BREAKPOINTS = {
  sm: '(min-width: 640px)', // Small (e.g., phones)
  md: '(min-width: 768px)', // Medium (e.g., tablets)
  lg: '(min-width: 1024px)', // Large (e.g., laptops)
  xl: '(min-width: 1280px)', // Extra Large (e.g., desktops)
  '2xl': '(min-width: 1536px)', // 2XL (e.g., large desktops)
};
